module.exports = __webpack_public_path__ + "img/4-01-05-address.b2c14436.svg";